import React, { useState } from 'react';
import VideoModal from '../video-modal/VideoModal';
import './ArticleVideo.scss';

const ArticleVideo = (data: { text: string; idVideo: string }) => {
    const [showVideo, setShowVideo] = useState(false);

    return (
        <>
            <span
                className="a-article-button"
                onClick={() => setShowVideo(true)}
                role="button"
                tabIndex={0}
            >
                {data.text}
            </span>

            {showVideo && (
                <VideoModal
                    closeVideoModal={() => setShowVideo(false)}
                    linkID={data.idVideo}
                />
            )}
        </>
    );
};

export default ArticleVideo;
